export default __webpack_public_path__ + "static/rectangle@2x-16086054b199c4907805bd6445f0bafd.png";